import { ColorPalette } from 'elements/minute/sidebar/sidebarComponents/complex/ColorPalette';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSubsection } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection';
import { IImageV2WorldMarker } from 'react-give-me-map/dist/utils/world/worldTypes';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IImageV2WorldMarker;
    onBackgroundChanged?: (color: string) => void;
}

export const ImageMarkerBackgroundSubsection = (props: Props): JSX.Element => {
    return (
        <S_ImageMarkerBackgroundSubsection className={props.className}>
            <SidebarSubsection
                title={Localization.BACKGROUND}
                icon={{ iconName: 'circle' }}
                disableBottomBorder
            >
                <SidebarContent>
                    <ColorPalette
                        value={props.marker.elementData.generatedBackgroundColor}
                        pickerAllowed
                        transparentAllowed
                        onChange={(color) => {
                            props.onBackgroundChanged?.(color);
                        }}
                    />
                </SidebarContent>
            </SidebarSubsection>
        </S_ImageMarkerBackgroundSubsection>
    );
};

const S_ImageMarkerBackgroundSubsection = styled.div``;
